import { inject, Injectable } from '@angular/core';
import { EMPTY_GUID } from '../../../shared/constants/global';
import { firstValueFrom, map, Observable } from 'rxjs';
import { HttpHelperService } from '../../../shared/services/http.service';
import { GlobalService } from '../../../shared/services/global.service';
import { HttpClient } from '@angular/common/http';
import { OrgAttributeRequestItem, OrgAttributeResponseItem } from '../vas-configurator.constants';

@Injectable({
  providedIn: 'root',
})
export class VCApiService {
  private http = inject(HttpHelperService);
  private httpc = inject(HttpClient);
  private globalService = inject(GlobalService);

  get finishedGoodsId(): string | null {
    return sessionStorage.getItem('FINISHED_GOODS_ID');
  }

  //temporary
  getFinishedGoodsViaSearch(pl: any, id = EMPTY_GUID): Observable<any> {
    return this.http.post(`api/FinishedGoods(${id})/GetFinishedGoods`, pl);
  }
  getConfiguratorFinishedGoodDetails(pl: any): Observable<any> {
    return this.http.post(
      `api/FinishedGoods(00000000-0000-0000-0000-000000000000)/GetConfiguratorFinishedGoodDetails`,
      pl,
    );
  }

  partSearch(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/PartSearch`, pl);
  }

  getOrgAttributes(pl: OrgAttributeRequestItem[]): Observable<OrgAttributeResponseItem[]> {
    return this.http.post(
      `api/FinishedGoods(${this.finishedGoodsId})/GetOrgAttributes`,
      pl as unknown as string,
    );
  }

  public getFinishedGoodDetails(finishedGoodsId: string): Observable<any> {
    return this.http.get('api/FinishedGoods(' + finishedGoodsId + ')/GetFinishedGoodDetails');
  }

  getSalesLocations(): Observable<void> {
    return this.globalService.lookupDataListCategories(['includeSalesLocationList']).pipe(
      map((res) => {
        sessionStorage.setItem('SALES_LOCATION_LIST', JSON.stringify(res.SalesLocations));
      }),
    );
  }

  public createSalesOrderWorkInstruction(pl: any, id: string): Observable<any> {
    return this.http.post(`api/WorkInstructions(${id})/AddSalesOrderWorkInstruction`, pl);
  }

  public getFinishedGoodLineItems(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/GetConfiguratorFinishedGoodLineItems`, pl);
  }


  public getLineAttachment(id: any, finishedGoodId?: string | null) {
    return this.http.get(
      `api/FinishedGoods(${finishedGoodId ?? this.finishedGoodsId})/FinishedGoodLineItems(${id})/GetFinishedGoodLineItemAttachments`,
    );
  }

  public getFinishedGoodAttachments(finishedGoodId?: string | null) {
    return this.http
      .get(
        `api/FinishedGoods(${finishedGoodId ?? this.finishedGoodsId})/GetFinishedGoodAttachments`,
      )
      .pipe(map((res) => res));
  }

  getSASToken(): Promise<any> {
    return firstValueFrom(
      this.http.get(`api/FinishedGoods(${this.finishedGoodsId})/GetSASToken?Container=docs`),
    );
  }
  public canUploadDocument(pl: any): Promise<any> {
    return firstValueFrom(
      this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/CanUploadDocument`, pl),
    );
  }
  public uploadFiles(pl: any) {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/FinishedGoodDocuments`, pl);
  }

  public uploadFileInContainer(url: string, file: string | File, type: string): Promise<any> {
    return firstValueFrom(
      this.httpc.put(url, file, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'content-type': type,
        },
      }),
    );
  }
  public getLineDocument(id: any, pl: any) {
    return this.http.post(
      `api/FinishedGoods(${this.finishedGoodsId})/FinishedGoodLineItems(${id})/FinishedGoodLineItemDocuments`,
      pl,
    );
  }

  public getPricingDetails(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/GetPricing`, pl);
  }

  public getSpaList(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/GetSPAList`, pl);
  }

  public multiplePartSearch(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/MultiplePartSearch`, pl);
  }
  public createConfiguratorLineItem(pl: any): Observable<any> {
    return this.http.post(
      `api/FinishedGoods(${this.finishedGoodsId})/CreateConfiguratorLineItem`,
      pl,
    );
  }

  public submitConfiguratorFinishedGood(pl: any): Observable<any> {
    return this.http.post(
      `api/FinishedGoods(${this.finishedGoodsId})/SubmitConfiguratorFinishedGood`,
      pl,
    );
  }

  public createNewConfiguratorFG(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${EMPTY_GUID})/SaveConfiguratorFinishedGood`, pl);
  }

  public updateConfiguratorFG(fgId: string, pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${fgId})/SaveConfiguratorFinishedGood`, pl);
  }

  getInventoryDetails(pl: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/GetInventory`, pl);
  }

  logVcFGSumbit(pl: any): Observable<any> {
    return this.http.post(`api/CreateInternalAPICallLog`, pl);
  }

  fetchLookupData(pl: any): Observable<any> {
    return this.http.post(`api/FetchLookupData`, pl);
  }

  getStockInventory(payload: any): Observable<any> {
    return this.http.post(`api/FinishedGoods(${this.finishedGoodsId})/GetStockInventory`, payload);
  }

  public getSupplierInformation(pl: any): Observable<any> {
    return this.http.post(`api/GetSupplierInformation`, pl);
  }
}
